import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=52d97da9&lang=html&"
import script from "./nav-item.vue?vue&type=script&lang=js&"
export * from "./nav-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d97da9')) {
      api.createRecord('52d97da9', component.options)
    } else {
      api.reload('52d97da9', component.options)
    }
    module.hot.accept("./nav-item.vue?vue&type=template&id=52d97da9&lang=html&", function () {
      api.rerender('52d97da9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/nav-item.vue"
export default component.exports